import { StandardTextFieldProps } from '@mui/material'
import { FieldError, FieldValues } from 'react-hook-form'

import { TextFieldProps } from './types'

type Props<T extends FieldValues> = Pick<
  TextFieldProps<T>,
  'fixedHelperText' | 'helperText' | 'useTooltipForErrors'
> & {
  errorMessage: FieldError['message']
  hasError: boolean
}

export const createHelperText = <T extends FieldValues>({
  errorMessage,
  fixedHelperText,
  hasError,
  helperText,
  useTooltipForErrors,
}: Props<T>): StandardTextFieldProps['helperText'] => {
  if (hasError && !useTooltipForErrors) {
    return errorMessage
  } else if (helperText) {
    return helperText
  } else if (fixedHelperText) {
    return ' '
  } else {
    return undefined
  }
}
